const getConfig = (env: string) => {
  if (window.Cypress) {
    env = 'test';
  }

  const defaults = {
    LANGUAGES: ['en', 'nl', 'de', 'pt', 'es', 'sk', 'no', 'fr', 'ru', 'lv'],
    isDevelopment: env === 'development',
    isProduction: env === 'production',
    isStaging: env === 'staging',
    isTest: env === 'test',
    env
  };

  switch (env) {
    case 'production':
      return {
        ...defaults,
        API_URL: 'https://api.salonized.com/widget_api',
        MIXPANEL_TOKEN: '0c5377ed69bfb72858dfd49157545a41'
      };
    case 'staging':
    case 'acceptance':
      return {
        ...defaults,
        API_URL: `${window.location.origin.replace('widget', 'api')}/widget_api`,
        MIXPANEL_TOKEN: '589f407e4d83027bf2acfb5829d8c74b'
      };
    case 'development':
      return {
        ...defaults,
        API_URL: 'http://app.salonized.fml:3000/widget_api',
        MIXPANEL_TOKEN: '7d147e9bb1642ace9472b6e9088b5561'
      };
    default:
      return {
        ...defaults,
        API_URL: 'http://test.salonized.fml/widget_api',
        MIXPANEL_TOKEN: '7d147e9bb1642ace9472b6e9088b5561'
      };
  }
};

export default Object.freeze(getConfig(import.meta.env.VITE_ENV));
